import { render } from "./DetailsTargetGroupModal.vue?vue&type=template&id=3a66917c"
import script from "./DetailsTargetGroupModal.vue?vue&type=script&lang=js"
export * from "./DetailsTargetGroupModal.vue?vue&type=script&lang=js"

import "./DetailsTargetGroupModal.vue?vue&type=style&index=0&id=3a66917c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__